import { render } from "./ProdutoDadosPrincipais.vue?vue&type=template&id=6e11c5fa&ts=true"
import script from "./ProdutoDadosPrincipais.vue?vue&type=script&lang=ts"
export * from "./ProdutoDadosPrincipais.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__